import React, { Fragment, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector, shallowEqual } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Grid, Text } from 'elements';
import { RootState } from 'modules';
import MentorFilterModal from 'components/modal/MentorFilterModal';
import { getQNAList } from 'libs/api/case';
import { getUrlQuery } from 'libs/utils';
import { toUpperCase } from 'libs/utils';
import { TRequestQNAList, TQNAList } from 'modules/case/types';
import { TModalState } from 'modules/types';
import { CWindowWidth } from 'constants/base.const';
import { CMentoringFieldType } from 'constants/mentoring.const';
import { EmployedTypes } from 'enums/base.enum';
import { ERoute } from 'enums/route.enum';
import { Button, Select, Pagination, Spin, Input, Tabs } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Colors, SecondaryColor, PrimaryColor } from 'GlobalStyles';
import DefaultUser from 'assets/icons/default.webp';
import MainBackImage from 'assets/images/banners/4.webp';

const { TabPane } = Tabs;

//필터 없음
type TCaseQNAFilter = {
  company?: string;
  hired_type?: string;
  location?: string;
  interview?: string;
  is_answered?: string;
};

//쿼리 타입
type TQuery = {
  page?: string;
  order?: string;
  selected?: string;
  is_mine?: string;
  company?: string;
  hired_type?: string;
  location?: string;
  interview?: string;
  search?: string;
  is_answered?: string;
};

let timeout: number = 0;

const MentoringQNA = () => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const [key, setKey] = useState('');
  const location = useLocation();
  const queries: TQuery = getUrlQuery(decodeURI(location.search));
  const history = useHistory();
  const limit = 10;
  const [list, setList] = useState<Array<TQNAList>>();
  const [page, setPage] = useState<number>(queries.page ? Number(queries.page) : 1);
  const [total, setTotal] = useState<number>(1);
  const [selectedOrder, setSelectedOrder] = useState(queries.order || 'new');
  const [mentorFilterModal, setMentorFilterModal] = useState<TModalState>({
    record: '',
    visible: false,
  });
  const [filter, setFilter] = useState<TCaseQNAFilter>({
    // company: queries.company,
    // hired_type: queries.hired_type,
    // location: queries.location,
    // interview: queries.interview,
    // is_answered : queries.is_answered,
    // category:queries.category,
    // sub_category:queries.sub_category,
  });
  //검색 기능  : 쿼리스트링에서 search 값이 있다는것은 검색을 했다는것
  const [search, setSearch] = useState(queries.search || '');
  const CUTBODYLENGTH = 300;

  const openFilter = () => {
    setMentorFilterModal({
      visible: true,
      type: 'QNA',
      //필터 모달에서 확인을 눌렀을 때 만들어진 객체(value)를 활용해서 filter 상태 바꿔주는 setFilter 실행
      onFinish: ({ company, hired_type, location, interview, is_answered }: TCaseQNAFilter) => {
        setFilter({ company, hired_type, location, interview, is_answered });
      },
    });
  };

  const getList = async () => {
    const replaceAll = (str: string, target: string, replace: string) => {
      return str.split(target).join(replace);
    };

    // 기본적인 params
    const params: any = {
      current: page,
      pageSizes: limit,
      // bookmark: selected === 'bookmark' ? 'bookmark' : undefined,
      // my_library: isMine ? 'my_library' : undefined,
      q: search || undefined,
      mentoring_field: currentUser?.primary_field ? currentUser?.primary_field : 'consulting',
    };

    //필터에 값이 있으면 만들어지는 params
    if (filter) {
      //filter객체의 key 값으로만 이루어진 배열을 만든다 ==> 그 배열의 값들을 순서대로 대입(forEach)
      // params 객체 설정
      Object.keys(filter).forEach((key: string) => {
        if (filter[key as keyof TCaseQNAFilter])
          params[key] = replaceAll(filter[key as keyof TCaseQNAFilter] || '', '+', '*');
      });
    }

    //정렬에 변화가 있으면 만들어지는 params에 selectedOrder프로퍼티 넣어주기
    params[selectedOrder] = selectedOrder;

    //params 넘김
    const { success, data } = await getQNAList(params as TRequestQNAList);
    if (success) {
      setTotal(data.total);
      setList(
        data.contents.map((content: any) => {
          if (content.hired_type) {
            //hired_type 영어로 된 것을 한글 텍스트로 바꾼다
            const finded = EmployedTypes.find((t) => t.value === content.hired_type);
            if (finded) content.hired_type_text = finded.text;
          }
          return content;
        }),
      );
    }

    //기본 ==> {current: 1, pageSizes: 10, q: undefined, new: "new"}
  };

  //url쿼리 만들기
  const routeQuery = () => {
    const newQuries = [`page=${page}`, `order=${selectedOrder}`];

    if (filter) {
      Object.keys(filter).forEach((key: string) => {
        if (filter[key as keyof TCaseQNAFilter])
          newQuries.push(`${key}=${filter[key as keyof TCaseQNAFilter]}`);
      });
    }
    // if (isMine) newQuries.push('is_mine=true');
    // if (selected) newQuries.push(`selected=${selected}`);
    if (search) newQuries.push(`search=${search}`);

    history.replace(`${ERoute.MentoringQNA}?${newQuries.join('&')}`);

    getList();
  };

  // const bookmark = async (id: number) => {
  //   const { success } = await bookmarkLibrary(id);
  //   if (success) getList()
  // }

  useEffect(() => {
    if (list) {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(routeQuery, 500);
    }
  }, [search]);

  useEffect(() => {
    if (list) {
      if (page === 1) {
        routeQuery();
      } else setPage(1);
    }
  }, []);
  // }, [selected]);

  useEffect(() => {
    routeQuery();
  }, [filter, page, selectedOrder]);
  // }, [filter, isMine, page, selectedOrder]);

  const delHTMLTag = (str: string) => {
    const resultString = str
      .replace(/<\/?[^>]+(>|$)/g, '')
      .replaceAll('&nbsp;', '')
      .replace(/\n/g, ' ');
    return resultString;
  };

  return (
    <>
      {/* <Helmet>
        <title>{currentUser?.primary_field && CMentoringFieldType[currentUser?.primary_field]} - Q&A</title>
      </Helmet> */}
      {/* <CaseQNAAlertModal /> */}
      <Grid image={MainBackImage} imageSize='cover' height='300px' md={{ height: '250px' }}>
        <Grid height='100%' backgroundColor={`${Colors.black}33`} justify='center'>
          <Grid width={`${CWindowWidth}px`} padding='0 7%' align='center' md={{ padding: '0 2%' }}>
            <Grid>
              <Text color={Colors.white} size='50px' bold>
                Q&A
              </Text>
            </Grid>
            {currentUser?.primary_field === 'consulting' ? (
              <Grid marginTop='5px'>
                <Text color={Colors.white} size='16px' md={{ size: '12px' }}>
                  컨설팅 취업준비와 관련된 무엇이든 물어보세요. Career Step 멘토가 답해드립니다.
                </Text>
              </Grid>
            ) : (
              <Grid marginTop='5px'>
                <Text color={Colors.white} size='16px' md={{ size: '12px' }}>
                  취업준비와 관련된 무엇이든 물어보세요. Career Step 멘토가 답해드립니다.
                </Text>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>

      <Tabs
        // activeKey={key}
        // onChange={(e) => {
        //   setKey(e);
        // }}
        centered={true}
      >
        {currentUser?.primary_field && (
          <TabPane tab={`${toUpperCase(currentUser?.primary_field)} Q&A`} key={ERoute.MentoringQNA}></TabPane>
        )}
      </Tabs>

      <Grid justify='center'>
        <Grid width={`${CWindowWidth}px`} padding='38px 20px 150px 20px'>
          <Grid justify='space-between' align='center'>
            <Grid isInline width='300px'>
              <Text size='1.1rem'>총 {total}개 Case</Text>
            </Grid>
            <Grid isInline maxWidth='280px' sm={{ maxWidth: '100%', width: '100%', marginTop: '8px' }}>
              <Input
                size='large'
                placeholder='검색어 입력'
                prefix={<SearchOutlined style={{ color: Colors.grey2 }} />}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Grid>
            {/* 큰 화면 사이즈 */}
            <Grid isInline width='300px' gap='16px' justify='flex-end' sm={{ display: 'none' }}>
              {/* <Button onClick={openFilter}>필터</Button> */}
              <Select value={selectedOrder} onChange={setSelectedOrder}>
                <Select.Option value={'new'}>최신순</Select.Option>
                {/* <Select.Option value={'view'}>조회순</Select.Option> */}
                <Select.Option value={'comment'}>댓글순</Select.Option>
              </Select>
            </Grid>
          </Grid>
          <Grid justify='flex-end' marginTop='16px' sm={{ display: 'none' }}>
            <Grid isInline gap='16px' align='center'>
              <Button className='outline large' onClick={() => history.push(ERoute.MentoringQNAWrite)}>
                글쓰기
              </Button>
            </Grid>
          </Grid>
          {/* 화면 작은 사이즈 */}
          <Grid
            display='none'
            justify='space-between'
            align='center'
            marginTop='12px'
            sm={{ display: 'flex' }}
          >
            <Grid isInline gap='8px'>
              {/* <Button onClick={openFilter}>필터</Button> */}
              <Select value={selectedOrder} onChange={setSelectedOrder}>
                <Select.Option value={'new'}>최신순</Select.Option>
                {/* <Select.Option value={'views'}>조회순</Select.Option> */}
                <Select.Option value={'comment'}>댓글순</Select.Option>
              </Select>
              <Button className='outline' onClick={() => history.push(ERoute.MentoringQNAWrite)}>
                글쓰기
              </Button>
            </Grid>
          </Grid>

          <Grid marginTop='16px'>
            {!list ? (
              <Grid justify='center' align='center' height='100px'>
                <Spin spinning />
              </Grid>
            ) : list.length === 0 ? (
              <Grid justify='center' align='center' height='100px'>
                <Text size='1.2rem'>데이터가 없습니다.</Text>
              </Grid>
            ) : (
              list.map((li) => (
                <Fragment key={li.id}>
                  <Grid
                    isNoWrap
                    gap='10px'
                    justify='space-between'
                    align='center'
                    margin='0 0 50px 0'
                    padding='14px 20px'
                    borderRadius='8px'
                    style={{
                      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
                      cursor: 'pointer',
                    }}
                    // sm={{ display: 'none' }}
                  >
                    <Grid onClick={() => history.push(`${ERoute.MentoringQNA}/${li.id}`)}>
                      {/* 선택 카테고리 리스트 */}
                      <Grid>
                        {li.categories?.map((el: any) => (
                          <Button
                            className='small'
                            style={{
                              minHeight: '22px',
                              marginRight: '5px',
                              fontSize: '1rem',
                            }}
                            key={el.id}
                          >
                            {' '}
                            {el.name}{' '}
                          </Button>
                        ))}
                        {li.sub_categories?.map((el: any) => (
                          <Button
                            className='small'
                            style={{
                              minHeight: '22px',
                              marginRight: '5px',
                              fontSize: '1rem',
                            }}
                            key={el.id}
                          >
                            {' '}
                            {el.name}{' '}
                          </Button>
                        ))}
                        {/* {li.categories?.map((el:any ) => <Tag key={el.id} visible={true}> {el.name} </Tag>)}
                          {li.sub_categories?.map((el:any ) =>  <Tag key={el.id} visible={true}> {el.name} </Tag>)} */}
                      </Grid>

                      {/* 제목 */}
                      <Grid marginTop='16px'>
                        <Text size='1.6rem' style={{ fontWeight: 900 }}>
                          {li.title || '-'}
                        </Text>
                      </Grid>
                      {/* 본문 */}

                      {li.body && (
                        <Grid marginTop='16px'>
                          {delHTMLTag(li.body).length > CUTBODYLENGTH
                            ? `${delHTMLTag(li.body).slice(0, CUTBODYLENGTH)}...`
                            : delHTMLTag(li.body)}
                        </Grid>
                      )}

                      {/* 댓글 수 */}
                      <Grid marginTop='16px'>
                        <Text>Comments : {li.comment?.length}</Text>
                      </Grid>
                      <Grid marginTop='16px' border={`0.5px solid ${Colors.grey0}`} />

                      {/* 댓글 */}
                      {li.comment && (
                        <Grid marginTop='16px'>
                          {li.comment.slice(0, 3).map((comment: any) => (
                            <Grid>
                              <Grid gap='5px' align='center'>
                                <Grid
                                  isInline
                                  image={comment.created_by.profile_image.absolute_url || DefaultUser}
                                  width='40px'
                                  height='40px'
                                  borderRadius='40px'
                                />
                                <Grid isInline>{comment.created_by.fullname}</Grid>
                                {/* <Grid isInline padding='1px 8px' backgroundColor={SecondaryColor} borderRadius='4px'> */}
                                <Grid
                                  isInline
                                  padding='1px 8px'
                                  backgroundColor={
                                    comment.is_current === '시니어' ? PrimaryColor : SecondaryColor
                                  }
                                  borderRadius='4px'
                                >
                                  <Text color={Colors.white} size='0.9rem'>
                                    {comment.is_current}
                                  </Text>
                                </Grid>
                              </Grid>
                              <Grid>
                                <div className='ellipsis-line-1'>{comment.content}</div>
                              </Grid>
                            </Grid>
                          ))}
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Fragment>
              ))
            )}
          </Grid>
          <Grid marginTop='40px' justify='center'>
            <Pagination current={page} pageSize={limit} responsive total={total} onChange={setPage} />
          </Grid>
        </Grid>
      </Grid>

      <MentorFilterModal modalState={mentorFilterModal} setModalState={setMentorFilterModal} />
    </>
  );
};

export default MentoringQNA;
